// extracted by mini-css-extract-plugin
module.exports = {"birds_name":"BirdsList_birds_name__2HA_y","active":"BirdsList_active__2MuYJ"};